import React from 'react';
import { Vehicle } from 'core/models/vehicle';
import { Project } from 'core/models/project';
import { VisualizerWidget } from 'components/views/organisms/VisualizerWidget';
import { useAutowareVizOverMQTT } from 'services/viz/useAutowareVizOverMQTT';

export type VisualizerProps = {
    vehicleId: Vehicle.Id;
    projectId: Project.Id;
}

export function Visualizer(props: VisualizerProps) {
    const { vehicleId, projectId } = props;

    const engine = useAutowareVizOverMQTT(vehicleId, projectId);

    return <VisualizerWidget engine={engine} />;
}
